import Axios, { AxiosRequestConfig } from 'axios';

import { baseApiUrl } from '../../../config';
import { AxiosError, handleAxiosRequest } from '../../../utils';

export const AXIOS_INSTANCE = Axios.create({ baseURL: baseApiUrl });

export const customInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  return handleAxiosRequest(AXIOS_INSTANCE, config);
};

export type ErrorType<Error> = AxiosError<Error>;
